var _rect, _path, _rect2, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIc2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "#C0DCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0135 31H57V46H60.458C62.3328 46 63.956 44.6979 64.3627 42.8677L65.9183 35.8677C66.4734 33.3697 64.5725 31 62.0135 31Z",
    stroke: "#288BFF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 64,
    width: 52,
    height: 2,
    rx: 1,
    fill: "#288BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8065 26.7971L31.0925 23.7049C30.1458 21.9971 30.7628 19.8452 32.4706 18.8986V18.8986C34.1784 17.9519 34.7955 15.8 33.8488 14.0922L32.1348 11",
    stroke: "#288BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6429 26.7971L38.9289 23.7049C37.9822 21.9971 38.5993 19.8452 40.3071 18.8986V18.8986C42.0149 17.9519 42.6319 15.8 41.6853 14.0922L39.9712 11",
    stroke: "#288BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6429 26.7971L46.9289 23.7049C45.9822 21.9971 46.5993 19.8452 48.3071 18.8986V18.8986C50.0149 17.9519 50.6319 15.8 49.6853 14.0922L47.9712 11",
    stroke: "#288BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1631 32.0769C23.1183 31.496 23.5775 31 24.1601 31H56.8399C57.4225 31 57.8817 31.496 57.8369 32.0769L56.402 50.6917C56.0407 55.3801 52.1309 59 47.4287 59H33.5713C28.8691 59 24.9593 55.3801 24.598 50.6917L23.1631 32.0769Z",
    fill: "white",
    stroke: "#288BFF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc2);
export default __webpack_public_path__ + "static/media/ic_2.17c6b396fe69c68003c9458e9f2a03fe.svg";
export { ForwardRef as ReactComponent };